console.log("tables-init loaded", !!window.jQuery, !!(window.jQuery && jQuery.fn && jQuery.fn.tablesorter));

function initSortableTables(root = document) {
  if (!window.jQuery || !jQuery.fn || !jQuery.fn.tablesorter) return;

  // add class "sortable" to any tables you want sortable
  jQuery(root).find("table.sortable").each(function () {
    // prevent double init
    if (this.dataset.tablesorterInit) return;
    this.dataset.tablesorterInit = "1";
    jQuery(this).tablesorter();
  });
}

document.addEventListener("DOMContentLoaded", () => initSortableTables());

// when editing in theme editor, sections can reload
document.addEventListener("shopify:section:load", (e) => initSortableTables(e.target));